import React, { useEffect, useRef, useState, useContext } from "react";
import ReactDatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import en from 'date-fns/locale/en-US';
import it from 'date-fns/locale/it';
import fr from 'date-fns/locale/fr';
import ja from 'date-fns/locale/ja';
import ko from 'date-fns/locale/ko';
import zh from 'date-fns/locale/zh-CN';
import ru from 'date-fns/locale/ru';
import { getMonth, getYear, format, addDays, subDays } from 'date-fns';
import Select, { components } from "react-select";
import styles from "./Input.module.scss";
import { Controller } from "react-hook-form";
import ArrowRight from "../../public/assets/icons/arrowRight.svg";
import EyeClosed from "../../public/assets/icons/eyeClosed.svg";
import EyeOpen from "../../public/assets/icons/eyeOpen.svg";
import { faCaretDown, faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useWindowResize from "../../hooks/useWindowResize";
import { ApplicationContext } from "../../context/ApplicationContext";
import { countryList } from "../../countries";
import { useRouter } from 'next/router';

const prefixPlaceholder = {
  'en': 'i.e. +39',
  'it': 'Es. +39',
  'fr': 'Ex. +39',
  'jp': '例 +39',
  'kr': '예시 +39',
  'zh': '例如 +39',
  'ru': '+39'
};

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <FontAwesomeIcon
        icon={faCaretDown}
        size="xs"
        style={{ margin: "0 .35rem", fontSize: ".65rem" }}
      />
    </components.DropdownIndicator>
  );
};

const Input = ({
  text,
  name,
  type,
  placeholder,
  arrow = false,
  isItalic = false,
  inputProps,
  errorCheck,
  error,
  control,
  lightText = false,
  values,
  country = false,
  biggerSelect,
  selectOptions,
  value,
  disabled = false,
  myinfo = false,
  register = false,
  setProfiling,
  setBookingTime,
  date,
  setDate,
  booking,
  phone,
  phoneSplit,
  setPhone,
  setContact,
  setLanguage,
  setCategories,
  setType,
  formatOption,
  errorBookingCheck,
  mandatory,
  idCheck,
  setTitle

}) => {
  const [phonePrefix, setPhonePrefix] = useState('');
  const [phoneNum, setPhoneNum] = useState('');
  const [closed, setClosed] = useState(false);
  const [actualType, setActualType] = useState(type);
  const [actualOptions, setActualOptions] = useState();
  const datepickerSpan = useRef(null);
  const [datePresent, setDatePresent] = useState(false);
  const isMobile = useWindowResize("xl");
  const [countryConiq, setCountryConiq] = useState();
  const { myInfo } = useContext(ApplicationContext);
  const { registerData } = useContext(ApplicationContext);
  const [timeOptions, setTimeOptions] = useState();
  const countries = countryList.sort(function (a, b) {
    if (a.text < b.text) return -1;
    if (a.text > b.text) return 1;
    return 0;
  });
  const router = useRouter();

  const thisRef = useRef();
  const range = (start, stop, step = 1) =>
    Array(Math.ceil((stop - start) / step)).fill(start).map((x, y) => x + y * step);
  const years = range(1900, getYear(new Date()) + 1, 1);
  const [dateLang, setDateLang] = useState("en");
  const dateLocales = {
    "en": en,
    "it": it,
    "fr": fr,
    "ja": ja,
    "ko": ko,
    "zh": zh,
    "ru": ru
  };
  const [months, setMonths] = useState([
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ]);
  useEffect(() => {
    let regLang = "en";
    if (router.query?.locale && router.query.locale.length > 0) {
      regLang = router.query.locale;
      if (regLang == "jp") {
        regLang = "ja";
      }
      if (regLang == "kr") {
        regLang = "ko";
      }
      if (!(regLang in dateLocales)) {
        regLang = "en";
      }
    } else {
      const getLang = () => {
        if (navigator.languages != undefined)
          return navigator.languages[0];
        return navigator.language;
      };

      const l = getLang();
      if (l && l.split("-").length > 0) {
        regLang = l.split("-")[0];
      }
      if (!(regLang in dateLocales)) {
        regLang = "en";
      }
    }
    let ms = [];
    let r = range(0, 12);
    for (let i = 0; i < r.length; i++) {
      let month = (i + 1).toString();
      if (month < 10) {
        month = '0' + month;
      }
      let lm = format(new Date("2000-" + month), 'LLLL', { locale: dateLocales[regLang] });
      lm = lm[0].toUpperCase() + lm.substring(1);
      ms.push(lm);
    }
    setMonths(ms);
    registerLocale(regLang, dateLocales[regLang]);
    setDateLang(regLang);
  }, []);
  useEffect(() => {
    let countCi = 0;
    let ci = setInterval(() => {
      if (thisRef.current && thisRef.current.querySelector('input')) {
        const autoFill =
          window
            .getComputedStyle(thisRef.current.querySelector('input'), ':internal-autofill-selected')
            .getPropertyValue('appearance') === 'menulist-button';
        if (autoFill) {
          thisRef.current && thisRef.current.querySelector('input').focus();
          clearInterval(ci);
          return;
        }
        countCi++;
        if (countCi >= 10) {
          clearInterval(ci);
          return;
        }
      }
    }, 500)
  }, [thisRef]);

  useEffect(() => {
    /*document
    .querySelector('form')
    .querySelectorAll('input[type=text],input[type=password],input[type=email],input[type=number],input[type=tel]')
    .forEach((el) => {
      el.onfocus="this.__name = this.getAttribute('name'); this.removeAttribute('name')"
      el.onblur="this.setAttribute('name',this.__name)"
    })*/
    if (country) {
      const arr = countries.map((d) => ({
        label: d.text,
        value: d.value,
      }));
      setActualOptions(arr);
      if (value) {
        for (let i = 0; i < countries.length; i++) {
          if (countries[i].value === value) {
            setCountryConiq({
              label: countries[i].text,
              value: countries[i].value,
            });
            break;
          }
        }
      } else if (register) {
        setCountryConiq({
          label: "ITALY",
          value: "IT",
        });
        registerData.country = "IT"
      }
      else {
        setCountryConiq({
          label: "",
          value: "",
        });
      }
    } else if (selectOptions) {
      const arr = selectOptions.map((d) => ({
        label: d,
        value: d,
      }));
      setActualOptions(arr);
    }
    if (formatOption) {
      setActualOptions(formatOption)
    }
  }, [formatOption]);

  const handleClick = () => {
    setClosed(!closed);
    actualType === "password"
      ? setActualType("text")
      : setActualType("password");
  };

  const titleChange = (title) => {
    if (myinfo) {
      myInfo.title = title;
      myInfo.change = true;
      setTitle(myInfo.title)
    } else {
      registerData.title = title;
    }
  };

  const countryChange = (country) => {
    if (myinfo) {
      myInfo.country = country;
      myInfo.change = true;
      setProfiling(myInfo.country)
    } else {
      registerData.country = country;
      setProfiling(registerData.country)
    }
  };
  const timeChange = (time) => {
    setBookingTime(time)
    //setRequiredData(time)
  };

  const bookingChange = (e) => {
    if (idCheck === '5') {
      setType(e.value)
    }
    if (idCheck === '6') {
      setContact(e.value)
    }
    if (idCheck === '7') {
      setLanguage(e.value)
    }
    if (idCheck === '8') {
      setCategories(e.value)
    }
  };
  const phoneChange = (e) => {
    if(e.target.name == 'phone_prefix') {
      setPhonePrefix(e.target.value);
      if(phoneNum == '' || e.target.value == '')
        setPhone('');
      else
        setPhone(e.target.value+(phoneSplit ? ' ' : '')+phoneNum); 
    }
    else if (e.target.name == 'phone_num') {
      setPhoneNum(e.target.value);
      if(e.target.value == '' || phonePrefix == '')
        setPhone('');
      else
        setPhone(phonePrefix+(phoneSplit ? ' ' : '')+e.target.value);
    }
  }

  const colorStyles = {
    option: (styles, { isFocused, isSelected }) => {
      const bgColor = "#E9E9E9";
      const focusedColor = "#FFFFFF";
      const selectedColor = "#b1a38a";
      const textColor = "#1E1F23";

      if (isSelected) {
        return {
          ...styles,
          backgroundColor: selectedColor,
          color: textColor,
          fontWeight: "bold",
          paddingTop: "1.2rem",
          paddingBottom: "1.2rem"
        };
      }

      return {
        ...styles,
        color: textColor,
        fontWeight: isFocused ? "bold" : null,
        backgroundColor: isFocused ? focusedColor : bgColor,
        paddingTop: "1.2rem",
        paddingBottom: "1.2rem"
      };
    },
  };





  return (
    <div className={styles.Input} ref={thisRef}>
      {name && (
        <div>
          {text}
          <label
            className={
              styles.InputLabel + " " + (isItalic ? styles.italicInput : null) + (type === "radio key-value" ? ' '+styles.RadioList : '')
            }
            style={{
              border: type === "radio" ? "none" : null,
              height: type === "radio key-value" ? "fit-content" : null,
            }}
          >
            {type === "select" && countryConiq && !booking ? (
              <div
                className={`formSelect ${biggerSelect ? "biggerSelect" : null}`}
              >
                <label htmlFor="lang-selector"></label>
                {/* {
                  focus &&
                  <input
                  style={{
                    // height: "0",
                    // padding: "0",
                    // border: "0",
                    // cursor: "default",
                    // pointerEvents: "none",
                    // tabindex: "-1"
                  }}
                  name={name}
                  type="text"
                  defaultValue={registerData.country}
                  value={registerData.country}
                  {...inputProps}
                  tabindex="-1"
                  // onFocus={(e) => {e.preventDefault()}}
                  // disabled
                  // style={{display:"none"}}
                  onClick={(e) => e.preventDefault()}
                ></input>
                
                } */}
                <Select
                  components={{ DropdownIndicator }}
                  styles={colorStyles}
                  isSearchable={false}
                  classNamePrefix={styles.localeSelect}
                  className={styles.localeSelect}
                  options={actualOptions}
                  onChange={(e) => {
                    countryChange(e.value);
                  }}
                  defaultValue={countryConiq}
                />


                <span className={styles.selectPlaceholder}>{placeholder}</span>
              </div>
            ) : type === "date" && control && !disabled && !date ? (
              <div className={styles.datePicker}>
                <Controller
                  control={control}
                  name={name}
                  rules={{ required: true }}
                  render={({ field: { onChange, onBlur, value } }) => (
                    <ReactDatePicker
                      locale={dateLang}
                      customInput={
                        <input
                          className={styles.inputContainer}
                          style={{
                            backgroundImage:
                              'url("/assets/icons/calendar.svg")',
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: isMobile
                              ? "96% 50%"
                              : "95% 50%",
                            backgroundColor: "transparent",
                            height: "100%",
                          }}
                          autoComplete="off"
                        />
                      }
                      onClickOutside={() => {
                        if (
                          datepickerSpan.current.classList.contains(
                            styles.clicked
                          )
                        ) {
                          datepickerSpan.current.classList.remove(
                            styles.clicked
                          );
                        }
                        if (!value) {
                          setDatePresent(false);
                        } else {
                          setDatePresent(true);
                        }
                        if (value) {
                          datepickerSpan.current.classList.add(styles.clicked_);
                        } else if (
                          datepickerSpan.current.classList.contains(
                            styles.clicked_
                          )
                        ) {
                          datepickerSpan.current.classList.remove(
                            styles.clicked_
                          );
                        }
                      }}
                      onInputClick={() => {
                        if (datepickerSpan.current?.classList) {
                          datepickerSpan.current.classList.add(styles.clicked);
                        }
                        setDatePresent(true);
                      }}
                      onSelect={() => {
                        if (datepickerSpan.current?.classList) {
                          datepickerSpan.current.classList.add(styles.clicked);
                        }
                        setDatePresent(true);
                      }}
                      wrapperClassName="datepicker"
                      onChange={onChange}
                      onBlur={onBlur}
                      selected={value ? value : null}
                      dateFormat="dd/MM/yyyy"
                      openToDate={new Date()}
                      renderCustomHeader={({
                        date,
                        changeYear,
                        changeMonth,
                        decreaseMonth,
                        increaseMonth,
                        prevMonthButtonDisabled,
                        nextMonthButtonDisabled,
                      }) => (
                        <div
                          style={{
                            margin: 10,
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >

                          <select
                            value={months[getMonth(date)]}
                            onChange={({ target: { value } }) =>
                              changeMonth(months.indexOf(value))
                            }
                          >
                            {months.map((option) => (
                              <option key={option} value={option}>
                                {option}
                              </option>
                            ))}
                          </select>
                          <select
                            value={getYear(date)}
                            onChange={({ target: { value } }) => changeYear(value)}
                          >
                            {years.map((option) => (
                              <option key={option} value={option}>
                                {option}
                              </option>
                            ))}
                          </select>

                        </div>
                      )}
                    />
                  )}
                />
                <span
                  className={styles.dateFormat}
                  style={{ display: datePresent ? "none" : null }}
                >
                  DD / MM / YYYY
                </span>
                <span className={styles.datePlaceholder} ref={datepickerSpan}>
                  {placeholder}
                </span>
              </div>
            ) : type === "date" && control && !disabled && date ? (
              <div className={styles.datePickerBooking}>
                <Controller
                  control={control}
                  name={name}
                  rules={{ required: true }}
                  render={({ field: { onChange, onBlur, value } }) => (
                    <ReactDatePicker
                      excludeDateIntervals={[{ start: subDays(new Date(), 5000), end: addDays(new Date(), 0) }]}
                      open
                      locale={dateLang}
                      customInput={
                        <input
                          className={styles.inputContainer}
                          style={{
                            backgroundImage:
                              'url("/assets/icons/calendar.svg")',
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: isMobile
                              ? "96% 50%"
                              : "95% 50%",
                            backgroundColor: "transparent",
                            height: "100%",
                            visibility: 'hidden'
                          }}
                          autoComplete="off"
                        />
                      }
                      onClickOutside={() => {
                        if (
                          datepickerSpan.current.classList.contains(
                            styles.clicked
                          )
                        ) {
                          datepickerSpan.current.classList.remove(
                            styles.clicked
                          );
                        }
                        if (!value) {
                          setDatePresent(false);
                        } else {
                          setDatePresent(true);
                        }
                        if (value) {
                          datepickerSpan.current.classList.add(styles.clicked_);
                        } else if (
                          datepickerSpan.current.classList.contains(
                            styles.clicked_
                          )
                        ) {
                          datepickerSpan.current.classList.remove(
                            styles.clicked_
                          );
                        }
                      }}
                      onInputClick={() => {
                        const newDate = value.getMonth() < 10 ?
                          `${value.getFullYear()}-0${value.getMonth() + 1}-${value.getDate()}`
                          :
                          `${value.getFullYear()}-${value.getMonth() + 1}-${value.getDate()}`
                        setDate(newDate);
                        setDatePresent(true);
                      }}
                      onSelect={() => {

                      }}
                      wrapperClassName="datepicker"
                      onChange={onChange}
                      onBlur={onBlur}
                      selected={value ? value : null}
                      dateFormat="dd/MM/yyyy"
                      openToDate={addDays(new Date(), 1)}
                    />
                  )}
                />
                <span className={styles.datePlaceholder} ref={datepickerSpan}>
                  {''}
                </span>
              </div>
            )
              : type === "radio key-value" && values ? (
                <div className={styles.flexibility}>
                  <div>{placeholder}</div>
                  <div className={styles.radioBox}>
                    {values.map((d, i) => (
                      <div className={styles.radio} key={i}>
                        <input
                          name={name}
                          type="radio"
                          defaultChecked={
                            value
                              ? d.value == value
                                ? true
                                : false
                              // : i == 0
                              // ? true
                              : false
                          }
                          onClick={() => {
                            (myinfo || register) && titleChange(d);
                          }}
                          {...inputProps}
                        />
                        {d.key}
                      </div>
                    ))}
                  </div>
                </div>
              )
                : type === 'select' && booking ?
                  <div
                    className={`formSelect ${biggerSelect ? "biggerSelect" : null}`}
                  >
                    <Select
                      components={{ DropdownIndicator }}
                      styles={colorStyles}
                      isSearchable={false}
                      instanceId="select-mobile"
                      classNamePrefix={styles.localeSelect}
                      className={styles.localeSelect}
                      defaultValue={value}
                      options={actualOptions}
                      onChange={(e) => { bookingChange(e) }}
                      placeholder={''}
                    />

                    <span className={styles.selectPlaceholder}>{placeholder}</span>
                  </div>
                  : phone ?
                    <div className={`${styles.phoneWrapper}`}>
                      <div className={`${styles.phoneContainer} ${styles.inputContainer} ${disabled ? styles.inputContainerDisabled : null
                            }`}>
                        <input
                          onChange={phoneChange}
                          name={name+'_prefix'}
                          type={'number'}
                          placeholder={prefixPlaceholder[router.query.locale]}
                          style={{
                            color: lightText ? "#a9a9a9" : null,
                          }}
                        />
                        <input
                          onChange={phoneChange}
                          name={name+'_num'}
                          type={'number'}
                          placeholder="333 12345678"
                          style={{
                            color: lightText ? "#a9a9a9" : null,
                          }}
                        />
                      </div>
                      <span
                        className={`${styles.placeholder} `}
                      >
                        {placeholder}
                      </span>
                    </div>
                    : (
                      <div>
                        <input
                          className={`${styles.inputContainer} ${disabled ? styles.inputContainerDisabled : null
                            }`}
                          name={name}
                          type={actualType}
                          placeholder=" "
                          defaultValue={value}
                          {...inputProps}
                          style={{
                            color: lightText ? "#a9a9a9" : null,
                          }}
                          autoComplete="off"
                          readOnly={disabled}
                          onWheel={(e) => e.target.blur()}
                        />
                        <span
                          className={`${styles.placeholder} `}
                        >
                          {placeholder}
                        </span>
                      </div>
                    )}
            {arrow && (
              <button type="submit" className={styles.arrow}>
                <ArrowRight style={{ display: "block" }} />
              </button>
            )}
            {type === "password" && (
              <div className={styles.eyeContainer} onClick={handleClick}>
                {closed ? (
                  <EyeClosed style={{ display: "block" }} />
                ) : (
                  <EyeOpen style={{ display: "block" }} />
                )}
              </div>
            )}
            {errorCheck && (
              <div
                className={`${styles.error} ${type == "select" && !biggerSelect ? styles.selectError : null}`}
                style={{ bottom: (type == "password" ? "32px" : (type == "radio" ? "2px" : (type == "date" ? "1px" : null))) }}
              >
                <FontAwesomeIcon icon={faExclamationTriangle} />
                &nbsp;
                {error}
              </div>
            )}
            {errorBookingCheck && (
              <div
                className={styles.errorBookingCheck}
              >
                <FontAwesomeIcon icon={faExclamationTriangle} />
                &nbsp;
                {mandatory}
              </div>
            )}
          </label>
        </div>
      )}
    </div>
  );
};

export default Input;
